import {InjectionToken} from '@angular/core';

export interface AppAuthOptions {
	forms?: {
		login?: {
			redirectDelay?: number;
			strategy?: string;
			showMessages?: {error?: boolean; success?: boolean};
		};
		register?: {
			redirectDelay?: number;
			strategy?: string;
			showMessages?: {error?: boolean; success?: boolean};
		};
		requestPassword?: {
			redirectDelay?: number;
			strategy?: string;
			showMessages?: {error?: boolean; success?: boolean};
		};
		resetPassword?: {
			redirectDelay?: number;
			strategy?: string;
			showMessages?: {error?: boolean; success?: boolean};
		};
		validation?: {
			email?: {required?: boolean};
			password?: {required?: boolean; minLength?: number | null; maxLength?: number | null};
		};
	};
}

export const APP_AUTH_OPTIONS = new InjectionToken<AppAuthOptions>('APP_AUTH_OPTIONS');

export const DEFAULT_APP_AUTH_OPTIONS: AppAuthOptions = {
	forms: {
		login: {
			redirectDelay: 500,
			strategy: 'email',
			showMessages: {error: true, success: true},
		},
		register: {
			redirectDelay: 500,
			strategy: 'email',
			showMessages: {error: true, success: true},
		},
		requestPassword: {
			redirectDelay: 500,
			strategy: 'email',
			showMessages: {error: true, success: true},
		},
		resetPassword: {
			redirectDelay: 500,
			strategy: 'email',
			showMessages: {error: true, success: true},
		},
		validation: {
			email: {required: true},
			password: {required: true, minLength: null, maxLength: null},
		},
	},
};
